import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { loadEdc, showEdc } from 'Reduxes/pos/edc/edcActions'
import TableData from './TableData'
import FormElement from './FormElement'
import Detail from './Detail'

function Edc() {
    const { data, idShow } = useSelector(state => state.edcReducer)
    const dispatch = useDispatch()
    const [content, setContent] = useState('table')

    useEffect(() => {
        dispatch(loadEdc());
    }, [])

    const showTable = () => {
        setContent('table')
    }

    const showDetail = (id) => {
        dispatch(showEdc(id))
        setContent('detail')
    }

    const showForm = (type) => {
        setContent('form' + type)
    }

    const renderContent = (contentType) => {
        switch (contentType) {
            case 'table':
                return (<TableData showForm={showForm} showDetail={showDetail} />)
            case 'formNew':
                return (<FormElement type="new" showTable={showTable} />)
            case 'formEdit':
                return (<FormElement type="edit" showTable={showTable} />)
            case 'detail':
                return (<Detail showTable={showTable} data={data.filter(singleData => singleData.id === idShow)[0]} />)
            default:
                return <>Nothing to show here</>
        }
    }

    return (
        <>
            {
                renderContent(content)
            }
        </>
    )
}

export default Edc
